import { useEffect, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";

const RenderBackgroundLoader = ({ src }: { src: string }) => {
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (src) {
      const img = new Image();
      img.onload = () => {
        setLoading(false);
      };
      img.src = src;
      return () => {
        img.onload = null; // Clean up the onload handler
      };
    }
  }, [src]);

  return loading ? (
    <div className="upload-item__loader">
      <LoadingOutlined />
    </div>
  ) : null;
};

export default RenderBackgroundLoader;
